import type { UserRecord } from "@contract-manager/shared";

/**
 * Folds width and case so "ＳＵＺＵＫＩ", "suzuki" and "Suzuki" compare equal,
 * which is what someone typing through a Japanese IME expects.
 */
function normalise(text: string): string {
  return text.normalize("NFKC").toLowerCase();
}

/**
 * Keeps the users whose name or address contains every word of the query.
 * Words are split on any whitespace, full-width spaces included.
 */
export function filterUsers<T extends UserRecord>(
  users: readonly T[],
  query: string,
): readonly T[] {
  const words = normalise(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) {
    return users;
  }
  return users.filter((user) => {
    const haystack = normalise(`${user.displayName ?? ""} ${user.email}`);
    return words.every((word) => haystack.includes(word));
  });
}
